import {Injectable, inject} from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {RuntimeOrganizationService} from '../services/runtime-organization.service';

const ORG_ID_HEADER = 'X-Organization-Id';
const VANITY_HEADER = 'X-Organization-Vanity';
const PARENT_DOMAIN_HEADER = 'X-Parent-Domain';

@Injectable()

export class OrganizationIdInterceptor implements HttpInterceptor {
  private readonly runtimeOrganizationService: RuntimeOrganizationService = inject(RuntimeOrganizationService);

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<unknown>) => {
        if (!(event instanceof HttpResponse)) {
          return;
        }
        this.captureIdentityHeaders(request, event);
      })
    );
  }

  private captureIdentityHeaders(request: HttpRequest<unknown>, response: HttpResponse<unknown>): void {
    const organizationId = response.headers.get(ORG_ID_HEADER);
    const vanityName = response.headers.get(VANITY_HEADER);
    if (!organizationId || !vanityName) {
      return;
    }
    const origin = this.resolveParentOrigin(request);
    if (!origin) {
      return;
    }
    this.runtimeOrganizationService.setFromHeaders(origin, {organizationId, vanityName});
  }

  private resolveParentOrigin(request: HttpRequest<unknown>): string | null {
    const parentDomain = request.headers.get(PARENT_DOMAIN_HEADER);
    if (parentDomain) {
      return parentDomain;
    }
    return window.location.origin || null;
  }
}
